export type NetworkStatusState = 'offline' | 'online'

export const initialNetworkStatusState: NetworkStatusState = navigator.onLine ? 'online' : 'offline'
